import { render, staticRenderFns } from "./ApproveProcess.vue?vue&type=template&id=85ef55cc&scoped=true&"
import script from "./ApproveProcess.vue?vue&type=script&lang=js&"
export * from "./ApproveProcess.vue?vue&type=script&lang=js&"
import style0 from "./ApproveProcess.vue?vue&type=style&index=0&id=85ef55cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85ef55cc",
  null
  
)

export default component.exports